import React from 'react'
import styles from './ticket-sites.module.scss'
import PropTypes from 'prop-types'
import { commaDeliminate } from '../../../utilities/stringUtilities'
import { OverlayTrigger } from 'react-bootstrap'
import Tooltip from 'react-bootstrap/lib/Tooltip'
import { generatePath, Link } from 'react-router-dom'
import { ROUTES } from '../../../routes'

export default function SiteInfoCard ({ siteInfo, sitecostVisible, ticketSite }) {
  return (
    <div className={styles.infoCard}>
      <div>
        <Link to={generatePath(ROUTES.site, { id: ticketSite.id })}>{ticketSite.name}</Link>
        <span className={styles.siteItemName}>- {ticketSite.siteType.name}</span>
      </div>
      {(sitecostVisible || siteInfo.totalCost !== null || siteInfo.note) && <span className={styles.divider}>|</span>}
      {sitecostVisible && (
        <>
          <div>
            Disposal Cost (per ton): &nbsp;
            <span className={styles.siteItemCost}>
              {sitecostVisible ? `$${commaDeliminate(siteInfo.disposalCost)}` : '-'}
            </span>
          </div>
          {(siteInfo.totalCost !== null || siteInfo.note) && <span className={styles.divider}>|</span>}
        </>
      )}
      {siteInfo.totalCost !== null && (
        <>
          <div>
            Total Cost: &nbsp;
            <span className={styles.siteItemCost}>
              {siteInfo.totalCost !== null ? `$${commaDeliminate(siteInfo.totalCost)}` : '-'}
            </span>
          </div>
          {siteInfo.note && <span className={styles.divider}>|</span>}
        </>
      )}
      {
        siteInfo?.note && (
          <div>
            Note:&nbsp;&nbsp;
            <OverlayTrigger
              placement='top'
              overlay={<Tooltip id='dis-tooltip'>{siteInfo.note}</Tooltip>}>
              <span className={styles.costNote}>{siteInfo.note}</span>
            </OverlayTrigger>
          </div>
        )
      }
    </div>
  )
}

SiteInfoCard.propTypes = {
  siteInfo: PropTypes.object.isRequired,
  sitecostVisible: PropTypes.bool.isRequired,
  ticketSite: PropTypes.object.isRequired
}
